import React from 'react'
import './Login.css'
import { useState,useEffect} from 'react';
import eyeIcon from '../img/eye-gy-icon.svg'
import eyeSlashIcon from '../img/eyeslash-gy-icon.svg'

const Login = ({loginSet,userSet,apiSet,setCookie,setName}) =>{
    const [msje, setMsje] = useState(null)
    const [eye, setEye] = useState('show')
    const [counter, setCounter] = useState(0)


    const compare = (json)=>{
        if(json.auth === true){  
            setCounter(0)
            userSet(json.mail)
            apiSet(json.token)
            const token = json.id+" "+json.token
            //cookie dead after age....but remains untill website is closed
            //let age = 43200;//(in seconds) 43200==12 hours
            let age = 172800;//(in seconds) == 48 hours (updated on 1-01-24 at request of Marcos Villagra because of the screen on workshop)(updated directly on server (only age))
            setCookie('session_id', token, { path: '/',maxAge:age});
            setCookie('user', json.mail, { path: '/',maxAge:age});
            loginSet(true)      
        }
        else{
            setCounter(counter+1)
            setMsje("Error en usuario o password")
            console.log("auth filed")
           
        }
       
    }

    useEffect(() => {
        if(counter >= 4){
            setName('loader')
            const timeout = setTimeout(() => {
                setName('nitro')
              }, 30000)
              return () => clearTimeout(timeout) 
        }  
    },[counter]);



    function handleSubmit(e) {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
    
        const host = window.location.hostname;
        const isProd = process.env.NODE_ENV === 'production';
        let url = isProd
        ? 'http://localhost/react_projects/ISIGHT_v2/src/api/login/'
        : `http://${host}/react_projects/ISIGHT_v2/src/api/login/`; //para conectar ipad o ipone por red




        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        } else {
            url = "api/login/"
        }
        const formJson = Object.fromEntries(formData.entries());
        if(formJson.user === '' || formJson.pass === ''){
            setMsje("Debe completar todos los campos")
            return
        } 
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formJson.user)) {
            setMsje("Formato de correo incorrecto")
            return
        }
        setMsje(<span><p style={{color:'#99ff99'}}>{"Enviando..."}</p></span>)
        fetch(url,{method:"POST",body:JSON.stringify({
            r: formJson.user,
            n: formJson.pass
        }),headers:{"Content-Type":"application/json"}}).then(function(i){return i.json()})
        .then(function(i){
        compare(i)
        })  
        .catch(function(i){
        console.log("Error de session \n"+i)
        window.location.reload(false);
        })
    }
    
    return(
        <div className="body">
    <div className="form-container">
		<form autoComplete="off" className="out-square form" onSubmit={handleSubmit}>
			<div className="form-logo euro">ISIGHT</div>
			
            <div className="input-holder">

                <input autoComplete="off" name="user" className="form-input" type="text"  placeholder="  User email"  required=""/>

			    <input autoComplete="off" className="form-input" type={eye?"password":"text"} name="pass"  placeholder="  Isight Password" required=""/>

                <div className='pass-icon' onClick={()=>setEye(!eye)}>
                    {eye?<img src={eyeIcon}/>:<img src={eyeSlashIcon}/>}
                </div>
            </div>
			<button className="out-square form-btn euro" type="submit">Enviar</button>
			<div><small style={{color: '#4d6ae2'}} id="msje"></small></div>
			<div className="bottom-link"><small onClick={()=> setName('registro')}>Haga click AQUI para registrarse o recuperar su clave</small></div>
            <div className="bottom-msje">{msje}</div>
			<div className="power">Powered by Mine Blaster</div>
		</form>
	</div>
    </div>
    )
}

    export default Login


